import $http from '../http'
import { baseUrl } from '../url'
const BASEURL = baseUrl.primary + '/v1'
const BASEURL_DEV = BASEURL + '/ThirdParty/Email'

const email = {
  SentEmailToBankByNetCoreLogic(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SentEmailToBankByNetCoreLogic`,
      data
    })
  },
  SendEmailLogPage(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/SendEmailLogPage`,
      params
    })
  },
  SendEmailByNet(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SendEmailByNet`,
      data
    })
  },
}

export default email
